import React from "react";
import { NavLink } from "react-router-dom";
import { CalendarDays, ListChecks, Archive, Sprout } from "lucide-react";

const links = [
  { to: "/", label: "This week", icon: CalendarDays, end: true, testid: "nav-planner" },
  { to: "/priorities", label: "Priorities", icon: ListChecks, testid: "nav-priorities" },
  { to: "/activities", label: "Growth", icon: Sprout, testid: "nav-activities" },
  { to: "/archive", label: "Archive", icon: Archive, testid: "nav-archive" },
];

export const AppNav = () => {
  return (
    <nav className="flex flex-wrap items-center gap-1.5" data-testid="app-nav">
      {links.map((l) => {
        const Icon = l.icon;
        return (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.end}
            data-testid={l.testid}
            className={({ isActive }) =>
              `flex items-center gap-1.5 rounded-full px-3.5 py-1.5 font-sans text-sm transition-colors duration-300 ${
                isActive ? "bg-brand text-white" : "text-ink-soft hover:bg-clay-panel"
              }`
            }
          >
            <Icon className="h-4 w-4" />
            {l.label}
          </NavLink>
        );
      })}
    </nav>
  );
};
